export function format(first?: string, middle?: string, last?: string): string {
  return (first || '') + (middle ? ` ${middle}` : '') + (last ? ` ${last}` : '');
}

export function isNavegadorSankhya(userAgent: string): boolean {
  const REGEX_ELECTRON = new RegExp('Electron\\/([0-9\\.]*)');
  return REGEX_ELECTRON.test(userAgent);
}
